<template>
  <Form @submit="store" :validation-schema="schema">
    <div class="mt-5">
      <label class="text-sm text-gray-500" for="pin">{{ $lang.app.PIN }} <span class="text-red-500">*</span></label>
      <Field
          id="pin"
          name="pin"
          type="text"
          v-model="form.pin"
          class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
      />
      <ErrorMessage
          name="pin"
          class="text-xs text-red-400"
      />
    </div>
    <div class="mt-5">
      <label class="text-sm text-gray-500" for="surname">{{ $lang.app.SURNAME }} <span class="text-red-500">*</span></label>
      <Field
          id="surname"
          name="surname"
          type="text"
          v-model="form.surname"
          class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
      />
      <ErrorMessage
          name="surname"
          class="text-xs text-red-400"
      />
    </div>
    <div class="mt-5">
      <label class="text-sm text-gray-500" for="name">{{ $lang.app.NAME }} <span class="text-red-500">*</span></label>
      <Field
          id="name"
          name="name"
          type="text"
          v-model="form.name"
          class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
      />
      <ErrorMessage
          name="name"
          class="text-xs text-red-400"
      />
    </div>
    <div class="mt-5">
      <label class="text-sm text-gray-500" for="patronymic">{{ $lang.app.PATRONYMIC }}</label>
      <Field
          id="patronymic"
          name="patronymic"
          type="text"
          v-model="form.patronymic"
          class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
      />
      <ErrorMessage
          name="patronymic"
          class="text-xs text-red-400"
      />
    </div>
    <div class="mt-5">
      <label class="text-sm text-gray-500" for="birth-date">{{ $lang.app.BIRTH_DATE }} <span class="text-red-500">*</span></label>
      <Field
          id="birth-date"
          name="birthDate"
          type="date"
          v-model="form.birthDate"
          class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
      />
      <ErrorMessage
          name="birthDate"
          class="text-xs text-red-400"
      />
    </div>
    <div class="mt-5">
      <label class="text-sm text-gray-500" for="citizenship">{{ $lang.app.CITIZENSHIP }} <span class="text-red-500">*</span></label>
      <div class="mt-2">
        <Field
            id="citizenship"
            name="citizenship"
            v-slot="{ field }"
            class="w-full rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
        >
          <Multiselect
              class="border border-gray-200"
              v-bind="field"
              v-model="form.citizenship"
              :options="citizenships"
              :placeholder="$lang.app.SELECT_FROM_OPTIONS"
              valueProp="id"
              :searchable="true"
              :noOptionsText="$lang.app.LIST_EMPTY"
              :noResultsText="$lang.app.NOT_FOUND"
          >
          </multiselect>
        </Field>
        <ErrorMessage
            name="citizenship"
            class="text-xs text-red-400"
        />
      </div>
    </div>

    <div class="mt-5">
      <label class="text-sm text-gray-500">{{ $lang.app.ADDRESS }}</label>
      <div class="mt-2">
        <div v-if="!form.address" class="flex">
          <button type="button"
                  class="flex-shrink-0 px-4 py-2 text-sm text-center text-white bg-indigo-600 rounded-md focus:outline-none hover:bg-indigo-500"
                  @click="$emitter.emit('open-address-modal')">
            {{ $lang.app.ADD_ADDRESS }}
          </button>
          <ErrorMessage name="address" class="px-4 text-xs text-red-400"/>
        </div>
        <div v-if="form.address" class="flex items-center">
          <button type="button"
                  class="bg-indigo-700 rounded-md py-1 text-sm px-2 text-white focus:outline-none hover:shadow-lg"
                  :title="$lang.app.EDIT"
                  @click="$emitter.emit('open-address-modal')">
            <PencilIcon class="w-4 h-4 inline"/>
          </button>
          <div class="px-4 font-medium text-gray-700">
            {{ addressTxt }}
          </div>
        </div>

        <AddressModal @set-address="setAddress"/>
      </div>
    </div>

    <div class="mt-5 flex justify-end">
      <button type="submit"
              class="relative px-4 py-2 text-sm text-center text-white bg-green-500 rounded-md focus:outline-none hover:bg-green-400"
              :disabled="submitting">
        {{ $lang.app.SAVE }}
        <div v-if="submitting" class="absolute z-10 rounded w-full h-full top-0 left-0 bg-green-500 flex items-center justify-center">
          <div class="block animate-spin">
            <RefreshIcon class="w-6 h-6 mirror-y"/>
          </div>
        </div>
      </button>
    </div>

  </Form>
</template>
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import userApi from "../../../../api/users";
import AddressModal from "../../../modal/AddressModal";

export default {
  props: {
    profileId: Number,
    citizenships: Array,
  },
  components: {
    Form, Field, ErrorMessage,
    AddressModal,
  },
  data() {
    return {
      submitting: false,
      addressTxt: '',

      form: {
        pin: '',
        surname: '',
        name: '',
        patronymic: '',
        birthDate: '',
        citizenship: '',
        address: '',
      },
      schema: yup.object({
        citizenship: yup.mixed().required(),
        pin: yup.string().required(),
        surname: yup.string().required(),
        name: yup.string().required(),
        birthDate: yup.string().required(),
      })
    }
  },
  methods: {
    setAddress(id, addressTxt) {
      this.form.address = id
      this.addressTxt = addressTxt
    },
    store(values, actions) {
      this.submitting = true
      userApi.storePerson(this.profileId, this.form)
          .then(() => {
            this.$emitter.emit('refresh-profile')
          }).catch(error => {
        if (error.response.data.status === 422) {
          this.setValidationErrors(actions, error.response.data.errors)
        } else {
          this.$snotify.error(error)
        }
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>